import React from 'react';
import ReactDOM from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { initTelemetry } from './services/telemetry';
import App from './App';
import './index.css';

// Initialise Sentry before the React tree mounts so
// error capturing and performance tracing start immediately.
try {
  initTelemetry();
} catch {
  // Telemetry init must not block app startup
}

/**
 * Service-worker registration (registerType: 'prompt').
 *
 * `onNeedRefresh` fires when a new SW is installed and waiting.
 * We dispatch a custom event so the PWAUpdatePrompt component can
 * ask the user before activating it.
 *
 * `onOfflineReady` fires once the SW has pre-cached all assets.
 */
let updateSW: ((reloadPage?: boolean) => Promise<void>) | undefined;
try {
  updateSW = registerSW({
    onNeedRefresh() {
      window.dispatchEvent(
        new CustomEvent('sw-update-available', { detail: { updateSW } }),
      );
    },
    onOfflineReady() {
      console.info('[SW] App ready to work offline');
    },
  });
} catch {
  // SW registration must not block app startup
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
